// Multi-Geo & Multi-Language Dictionary for Dino World Festival 2026
import { GEOS } from './geoConfig.js';

export const baseTranslations = {
  // ================= ARABIC (Universal Middle East Base) =================
  ar: {
    langCode: 'ar',
    dir: 'rtl',
    langToggleLabel: 'ENGLISH',
    discount50Badge: 'خصم حصري 50%',
    step1Title: 'تذكرة كبار الشخصيات VIP الشاملة (خصم 50% اليوم)',
    step1Subtitle: 'تذكرة واحدة موحدة شاملة لجميع الفعاليات والمناطق والمفاجآت بدون تعقيد',
    vipPassBadge: 'التذكرة الرسمية الموحدة VIP • خصم 50%',
    vipCardTitle: 'تذكرة كبار الشخصيات VIP الشاملة (VIP All-Access)',
    vipCardTag: 'دخول سريع ذو أولوية + جميع المناطق الـ 5 + عروض السيرك + ركوب الديناصورات + هدايا',
    adultsLabel: 'تذاكر الكبار (Adults)',
    adultsAge: 'الأعمار 13 سنة فما فوق',
    kidsLabel: 'تذاكر الصغار (Children / Kids)',
    kidsAge: 'الأعمار من سنتين حتى 12 سنة (أقل من سنتين مجاناً)',
    vipInclusionsTitle: 'ما تتضمنه تذكرة VIP الشاملة بالكامل:',
    vipInclusions: [
      'الدخول السريع ذو الأولوية VIP (Fast Track) بدون أي انتظار أو طوابير',
      'وصول غير محدود لجميع المناطق الـ 5 (Zone A, B, C, D, E) وأكثر من 55 ديناصوراً متحركاً بالحجم الطبيعي',
      'مقاعد VIP الأمامية لحضور العرض الموسيقي وسيرك ما قبل التاريخ الحي (60 دقيقة)',
      'ركوب الأطفال للديناصورات التفاعلية الضخمة (Section C Dino Rides)',
      'التنقيب عن حفريات وعظام الديناصورات في الرمال ومختبر الاستكشاف',
      'هدية تذكارية رسمية مجانية (تيشيرت ديناصورات فاخر للكبار أو بيضة ديناصور مفاجأة للأطفال)',
      'دخول لاونج كبار الشخصيات VIP Lounge مع ضيافة متميزة'
    ],
    step2Title: 'بيانات الحجز واستلام التذاكر',
    step2Subtitle: 'ستصلك التذاكر الإلكترونية مع باركود الدخول السريع فوراً عبر البريد ورسالة نصية',
    openPassBanner: 'تذاكر مفتوحة 100% — صالحة للدخول في أي يوم يناسبك حتى 31 أكتوبر 2026 (09:00 ص – 09:00 م) بدون تعقيد أو حجز مواعيد مسبقة',
    popularBadge: 'الأكثر طلباً',
    saveText: 'وفرت:',
    totalAmount: 'الإجمالي للدفع:',
    standardTotal: 'السعر الأصلي:',
    continueBtn: 'متابعة الحجز وحجز المقاعد بخصم 50%',
    processingBtn: 'جاري حجز المقاعد...',
    ticketsCountLabel: 'عدد التذاكر:',
    ticketTypeLabel: 'نوع التذكرة:',
    perTicket: '/ تذكرة',
    perPackage: '/ باقة كاملة',
    types: {
      adult: 'تذكرة كبار (Adult)',
      kid: 'تذكرة صغار (Kids)',
      family: 'باقة العائلة (4 أفراد)'
    },
    tiers: {
      vip: {
        name: 'تذكرة كبار الشخصيات VIP الشاملة',
        tag: 'شاملة بالكامل لجميع المناطق والعروض والأنشطة',
        inclusions: [
          'الدخول السريع ذو الأولوية VIP (Fast Track) بدون أي انتظار أو طوابير',
          'وصول غير محدود لجميع المناطق الـ 5 (Zone A, B, C, D, E) وأكثر من 55 ديناصوراً متحركاً',
          'مقاعد VIP الأمامية لعرض سيرك الديناصورات الغنائي (60 دقيقة)',
          'ركوب الديناصورات للأطفال Dino Rides + التنقيب عن الحفريات',
          'هدية تذكارية رسمية مجانية + دخول لاونج كبار الشخصيات VIP Lounge'
        ]
      }
    },
    timeSlots: [
      { time: '09:00 - 11:00', label: 'الجلسة الصباحية الأولى', seats: '14 مقعد متبقي' },
      { time: '11:00 - 13:00', label: 'الجلسة الصباحية الثانية', seats: '8 مقاعد متبقية' },
      { time: '13:00 - 15:00', label: 'جلسة بعد الظهر الأولى', seats: '19 مقعد متبقي' },
      { time: '15:00 - 17:00', label: 'جلسة بعد الظهر الذهبية', seats: '6 مقاعد فقط!' },
      { time: '17:00 - 19:00', label: 'الجلسة المسائية الأولى', seats: '11 مقعد متبقي' },
      { time: '19:00 - 21:00', label: 'الجلسة المسائية الختامية', seats: '15 مقعد متبقي' }
    ],
    form: {
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      email: 'البريد الإلكتروني (لاستلام التذاكر والباركود)',
      phone: 'رقم الهاتف المحمول (للتأكيد)',
      notice: 'سيتم إرسال تذاكر الدخول الإلكترونية والباركود فوراً عبر البريد الإلكتروني ورسالة نصية'
    },
    summary: {
      selectedPackage: 'الباقة المختارة:',
      date: 'تاريخ الزيارة:',
      session: 'جلسة الدخول:',
      seatsCount: 'المقاعد المحجوزة:',
      originalPrice: 'السعر الأصلي:',
      discount50: 'خصم الحجز المبكر 50%:',
      finalTotal: 'الإجمالي النهائي:'
    },
    checkout: {
      navTitle: 'بوابة الدفع الآمنة',
      stepBadge: 'الخطوة النهائية • تأكيد الحجز',
      title: 'إتمام حجز التذاكر والدفع الإلكتروني',
      subtitle: 'تم تأمين مقاعدك لمدة 15 دقيقة بالسعر المخفض (50% خصم)',
      badge100Secure: 'دفع مشفر وآمن 100%',
      acceptedCardsTitle: 'البطاقات البنكية المعتمدة للدفع المباشر:',
      cardHolderLabel: 'الاسم على البطاقة',
      cardNumberLabel: 'رقم البطاقة الائتمانية / الخصم',
      expiryLabel: 'تاريخ الانتهاء (MM/YY)',
      cvvLabel: 'رمز الأمان (CVV)',
      confirmPayBtn: 'تأكيد ودفع',
      processingPayment: 'جاري تأكيد الحجز...',
      secureNotice: 'جميع المعاملات المالية مشفرة وآمنة وفق معايير PCI-DSS المصرفية العالمية.',
      orderReviewTitle: 'ملخص حجز المقاعد المؤكد',
      seatsHeldBadge: 'مقاعد مؤكدة الحجز',
      seatsCount: 'عدد التذاكر:',
      dateTime: 'الموعد والجلسة:',
      discountSaved: 'تم توفير (50%):',
      finalDue: 'المبلغ الإجمالي للدفع:',
      timerTitle: 'المقاعد محجوزة لك لمدة:',
      seatLabel: 'رمز المقعد المحجوز:',
      summaryTitle: 'ملخص حجز التذاكر',
      ticketTierLabel: 'فئة الباقة:',
      selectedDateLabel: 'تاريخ الزيارة:',
      sessionTimeLabel: 'وقت الجلسة:',
      attendeeNameLabel: 'اسم صاحب الحجز:',
      attendeeEmailLabel: 'البريد الإلكتروني:',
      paymentDetailsTitle: 'تفاصيل بطاقة الدفع'
    },
    guarantees: [
      { title: 'تذاكر رسمية 100%', desc: 'إصدار فوري لباركود الدخول الرسمي عبر البريد والرسائل' },
      { title: 'حجز مقاعد مضمون', desc: 'تأكيد فوري للمقاعد مع إمكانية تعديل موعد الزيارة مجاناً' },
      { title: 'دفع إلكتروني آمن 100%', desc: 'تشفير مصرفي معتمد وحماية كاملة للبيانات' }
    ],
    final: {
      badge: 'تم تأكيد الحجز بنجاح',
      confirmedTitle: 'تم تأكيد حجز تذكرتك بنجاح!',
      confirmedSubtitle: 'تم إرسال التذاكر الإلكترونية الرسمية مع باركود الدخول السريع إلى:',
      eventLabel: 'الفعالية:',
      venueLabel: 'المكان:',
      sessionLabel: 'الموعد والجلسة:',
      bookingRefLabel: 'رمز الحجز الإلكتروني:',
      packageLabel: 'نوع الباقة:',
      backHomeBtn: 'العودة للصفحة الرئيسية'
    }
  },

  // ================= ENGLISH (Universal Base) =================
  en: {
    langCode: 'en',
    dir: 'ltr',
    langToggleLabel: 'العربية',
    discount50Badge: '50% OFF TODAY',
    step1Title: 'Official VIP All-Access Pass (50% OFF Today)',
    step1Subtitle: 'One universal all-inclusive VIP pass for the entire family — all zones & shows included',
    vipPassBadge: 'OFFICIAL ALL-INCLUSIVE VIP PASS • 50% OFF',
    vipCardTitle: 'Universal VIP All-Access Pass',
    vipCardTag: 'Fast-Track Entry + All 5 Zones + Musical Circus + Dino Rides + Souvenirs',
    adultsLabel: 'Adult Tickets',
    adultsAge: 'Ages 13 and above',
    kidsLabel: 'Children Tickets',
    kidsAge: 'Ages 2 to 12 (Infants under 2 enter free)',
    vipInclusionsTitle: 'What’s Included in Your VIP Pass:',
    vipInclusions: [
      'VIP Priority Fast-Track Entry (Skip all regular lines and wait times)',
      'Unlimited All-Access to all 5 Dinosaur Zones & 55+ Life-Sized Animatronics',
      'VIP Front-Row Seating for the 60-Minute Live Musical Dinosaur Circus Show',
      'Interactive Dinosaur Riding for Kids (Section C Dino Rides)',
      'Fossil Excavation Sandpits & Prehistoric Science Discovery Zones',
      'Free Official Souvenir Gift (Deluxe Dino T-Shirt or Surprise Hatching Egg)',
      'Exclusive VIP Lounge Access with Complimentary Refreshments'
    ],
    step2Title: 'Attendee Details & Ticket Delivery',
    step2Subtitle: 'Your fast-track e-tickets with QR codes will be delivered instantly via Email and SMS',
    openPassBanner: '100% Flexible Open Tickets — Valid for entry any day until 31 October 2026 (09:00 AM – 09:00 PM). No date or time reservation needed!',
    popularBadge: 'MOST POPULAR',
    saveText: 'You Saved:',
    totalAmount: 'Total Payable:',
    standardTotal: 'Standard Total:',
    continueBtn: 'Continue & Reserve Seats with 50% OFF',
    processingBtn: 'Reserving Seats...',
    ticketsCountLabel: 'Number of Tickets:',
    ticketTypeLabel: 'Ticket Type:',
    perTicket: '/ ticket',
    perPackage: '/ package',
    types: {
      adult: 'Adult Ticket',
      kid: 'Child Ticket',
      family: 'Family Pass (4 Pax)'
    },
    tiers: {
      vip: {
        name: 'Universal VIP All-Access Pass',
        tag: 'All-inclusive pass for all zones, shows and activities',
        inclusions: [
          'VIP Priority Fast-Track Entry (Skip all lines)',
          'Unlimited access to all 5 Zones & 55+ life-sized animatronics',
          'VIP front-row seats for 60-min live musical circus show',
          'Children dinosaur rides (Dino Rides) + fossil dig sandpits',
          'Free official souvenir gift + VIP Lounge access'
        ]
      }
    },
    timeSlots: [
      { time: '09:00 - 11:00', label: 'Morning Session 1', seats: '14 seats left' },
      { time: '11:00 - 13:00', label: 'Morning Session 2', seats: '8 seats left' },
      { time: '13:00 - 15:00', label: 'Afternoon Session 1', seats: '19 seats left' },
      { time: '15:00 - 17:00', label: 'Peak Afternoon Session', seats: '6 seats left!' },
      { time: '17:00 - 19:00', label: 'Evening Prime Session', seats: '11 seats left' },
      { time: '19:00 - 21:00', label: 'Closing Evening Session', seats: '15 seats left' }
    ],
    form: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address (For Barcode & e-Tickets)',
      phone: 'Mobile Phone Number (For Confirmation)',
      notice: 'Your official e-tickets with QR codes will be delivered instantly via Email and SMS.'
    },
    summary: {
      selectedPackage: 'Selected Package:',
      date: 'Date of Visit:',
      session: 'Session Time:',
      seatsCount: 'Reserved Seats:',
      originalPrice: 'Original Price:',
      discount50: '50% Early Bird Discount:',
      finalTotal: 'Final Payable Total:'
    },
    checkout: {
      navTitle: 'Official Secure Checkout',
      stepBadge: 'Final Step • Reservation Confirmation',
      title: 'Complete Ticket Reservation & Payment',
      subtitle: 'Your seats have been temporarily reserved for 15 minutes at 50% OFF.',
      badge100Secure: '100% Encrypted & Bank-Grade Secure',
      acceptedCardsTitle: 'Accepted Direct Payment Methods:',
      cardHolderLabel: 'Name on Card',
      cardNumberLabel: 'Card Number',
      expiryLabel: 'Expiry (MM/YY)',
      cvvLabel: 'CVV Security Code',
      confirmPayBtn: 'Pay & Confirm',
      processingPayment: 'Processing Payment...',
      secureNotice: 'All payment transactions are encrypted and processed in strict compliance with PCI-DSS banking standards.',
      orderReviewTitle: 'Confirmed Reservation Summary',
      seatsHeldBadge: 'Seats Held for You',
      seatsCount: 'Ticket Count:',
      dateTime: 'Date & Session:',
      discountSaved: 'You Saved (50%):',
      finalDue: 'Total Amount Due:',
      timerTitle: 'Seats reserved for you:',
      seatLabel: 'Reserved Seat Code:',
      summaryTitle: 'Ticket Reservation Summary',
      ticketTierLabel: 'Ticket Package:',
      selectedDateLabel: 'Visit Date:',
      sessionTimeLabel: 'Session Time:',
      attendeeNameLabel: 'Attendee Name:',
      attendeeEmailLabel: 'Email Address:',
      paymentDetailsTitle: 'Payment Card Details'
    },
    guarantees: [
      { title: '100% Official Tickets', desc: 'Instant official entry barcode QR delivered via email & SMS' },
      { title: 'Guaranteed Entry', desc: 'Instant seat confirmation with free date change option' },
      { title: 'Bank-Grade 256-bit Security', desc: 'PCI-DSS certified encrypted & secure online checkout' }
    ],
    final: {
      badge: 'Booking Confirmed Successfully',
      confirmedTitle: 'Your Ticket Reservation is Confirmed!',
      confirmedSubtitle: 'Official e-tickets with express entry QR barcodes have been sent to:',
      eventLabel: 'Event:',
      venueLabel: 'Venue:',
      sessionLabel: 'Session:',
      bookingRefLabel: 'Reservation Reference:',
      packageLabel: 'Ticket Package:',
      backHomeBtn: 'Back to Event Homepage'
    }
  },

  // ================= TRADITIONAL CHINESE (Hong Kong Base) =================
  zh: {
    langCode: 'zh',
    dir: 'ltr',
    langToggleLabel: 'ENGLISH',
    discount50Badge: '早鳥限定 50% OFF',
    step1Title: '官方尊尚全包 VIP 通行證（早鳥半價 50% OFF）',
    step1Subtitle: '單一全包 VIP 通行證，暢玩所有展區與精彩活動，簡單明瞭',
    vipPassBadge: '官方全包 VIP 通行證 • 早鳥 50% OFF',
    vipCardTitle: '尊尚全包 VIP 通行證 (VIP All-Access Pass)',
    vipCardTag: '快速通道優先入場 + 全通5大展區 + 60分鐘歌舞馬戲 + 騎乘恐龍 + 正品紀念禮包',
    adultsLabel: '成人門票 (Adult)',
    adultsAge: '13歲或以上人士',
    kidsLabel: '兒童特惠門票 (Child)',
    kidsAge: '2至12歲（2歲以下嬰幼兒免費入場）',
    vipInclusionsTitle: 'VIP 通行證包含之全部特權：',
    vipInclusions: [
      'VIP 尊尚快速通道優先入場（免排隊無阻通關）',
      '全場5大展區全通暢玩，探秘超過55隻原大動態機械巨型恐龍',
      '60分鐘大型史前恐龍奇幻歌舞馬戲劇場 VIP 頭等尊席',
      '兒童親身騎乘機械動態巨龍體驗 (Section C Dino Rides)',
      '恐龍骨骼化石沙坑挖掘與史前科普探索區',
      '官方正品紀念禮包：成人限定精美T恤 或 兒童恐龍孵化奇趣蛋',
      '專屬 VIP 尊貴休息室禮遇及免費茶點招待'
    ],
    step2Title: '填寫取票人資料及接收電子門票',
    step2Subtitle: '電子門票連同專屬快速入場二維碼 (QR Code) 將即時發送至閣下之電子郵箱',
    openPassBanner: '100% 彈性開放通行證 — 2026年10月31日前任何營業日隨時直接入場 (09:00 - 21:00)，無需繁瑣預約場次！',
    popularBadge: '最多家庭選擇',
    saveText: '已立減節省：',
    totalAmount: '應付總額：',
    standardTotal: '原價總額：',
    continueBtn: '確認場次並以半價預留門票',
    processingBtn: '正在鎖定門票配額...',
    ticketsCountLabel: '門票數量：',
    ticketTypeLabel: '門票類別：',
    perTicket: '/ 張',
    perPackage: '/ 家庭套票',
    types: {
      adult: '成人票 (Adult)',
      kid: '兒童特惠票 (Kids)',
      family: '家庭四人套票 (Family Pass)'
    },
    tiers: {
      vip: {
        name: '尊尚全包 VIP 通行證',
        tag: '全場5大展區及全部項目一票全包',
        inclusions: [
          'VIP 尊尚快速通道優先入場（免排隊）',
          '全通5大展區及超過55隻原大動態機械恐龍',
          '60分鐘大型史前恐龍歌舞馬戲 VIP 頭等尊席',
          '兒童騎乘機械動態恐龍 + 恐龍化石沙坑挖掘探秘',
          '官方正品紀念禮包 + VIP 尊貴休息室款待'
        ]
      }
    },
    timeSlots: [
      { time: '09:00 - 11:00', label: '早場首節', seats: '餘下 14 個名額' },
      { time: '11:00 - 13:00', label: '早場次節', seats: '餘下 8 個名額' },
      { time: '13:00 - 15:00', label: '下午首節', seats: '餘下 19 個名額' },
      { time: '15:00 - 17:00', label: '下午黃金場', seats: '僅餘 6 個名額！' },
      { time: '17:00 - 19:00', label: '黃昏場次', seats: '餘下 11 個名額' },
      { time: '19:00 - 21:00', label: '夜間閉幕場', seats: '餘下 15 個名額' }
    ],
    form: {
      firstName: '名字 (First Name)',
      lastName: '姓氏 (Last Name)',
      email: '電子郵箱 (接收電子門票及入場 QR 碼)',
      phone: '流動電話號碼 (接收預訂確認短信)',
      notice: '付款完成後，包含 QR Code 的官方電子門票將立即發送至閣下的電子郵箱及電話短信。'
    },
    summary: {
      selectedPackage: '已選門票套裝：',
      date: '入場參觀日期：',
      session: '入場時段場次：',
      seatsCount: '預留門票名額：',
      originalPrice: '原價合計：',
      discount50: '早鳥限定半價立減：',
      finalTotal: '最終應付金額：'
    },
    checkout: {
      navTitle: '官方安全結賬系統',
      stepBadge: '最後一步 • 預訂門票確認',
      title: '完成門票預留及在線付款',
      subtitle: '閣下的早鳥半價優惠名額已獲系統鎖定 15 分鐘。',
      badge100Secure: '100% 銀行級 SSL 數據加密安全',
      acceptedCardsTitle: '支援之官方銀行卡即時付款方式：',
      cardHolderLabel: '持卡人姓名 (如卡面所示)',
      cardNumberLabel: '信用卡 / 扣賬卡號碼',
      expiryLabel: '有效期限 (MM/YY)',
      cvvLabel: '安全碼 (CVV)',
      confirmPayBtn: '確認付款並出票',
      processingPayment: '正在加密處理付款...',
      secureNotice: '所有付款交易均經由銀行級 PCI-DSS 高度加密協議安全處理。',
      orderReviewTitle: '已確認預留訂單摘要',
      seatsHeldBadge: '已為閣下鎖定名額',
      seatsCount: '門票總數：',
      dateTime: '入場日期及場次：',
      discountSaved: '早鳥已節省 (50%)：',
      finalDue: '應付總額：',
      timerTitle: '為閣下保留名額時間剩餘：',
      seatLabel: '已鎖定座位編號：',
      summaryTitle: '門票預訂摘要',
      ticketTierLabel: '門票級別：',
      selectedDateLabel: '參觀日期：',
      sessionTimeLabel: '入場時段：',
      attendeeNameLabel: '持票人姓名：',
      attendeeEmailLabel: '電子郵箱：',
      paymentDetailsTitle: '付款銀行卡資料'
    },
    guarantees: [
      { title: '100% 官方正品門票', desc: '付款後即時發送官方專屬入場 QR 碼至電子郵箱及電話短信' },
      { title: '名額鎖定 保證入場', desc: '即時確認入場名額，支援同等場次免費改期' },
      { title: '銀行級加密安全支付', desc: '符合 PCI-DSS 國際金融標準，全程高強度 SSL 加密防護' }
    ],
    final: {
      badge: '預留確認成功',
      confirmedTitle: '閣下的門票預留已成功確認！',
      confirmedSubtitle: '包含入場專屬 QR Code 的官方電子門票已即時發送至：',
      eventLabel: '活動名稱：',
      venueLabel: '展覽場地：',
      sessionLabel: '入場場次：',
      bookingRefLabel: '預留確認編號：',
      packageLabel: '門票套裝：',
      backHomeBtn: '返回官方活動首頁'
    }
  }
};

const GEO_OVERRIDES = {
  qa: {
    countryBadge: { ar: 'دولة قطر | الدوحة', en: 'State of Qatar | Doha' },
    headerTitle: { ar: 'مهرجان عالم الديناصورات قطر 2026', en: 'Dinosaur World Festival Qatar 2026' }
  },
  ph: {
    countryBadge: { en: 'Philippines | Metro Manila' },
    headerTitle: { en: 'Dinosaur World Festival Philippines 2026' }
  },
  om: {
    countryBadge: { ar: 'سلطنة عُمان | مسقط', en: 'Sultanate of Oman | Muscat' },
    headerTitle: { ar: 'مهرجان عالم الديناصورات سلطنة عُمان 2026', en: 'Dinosaur World Festival Oman 2026' }
  },
  kw: {
    countryBadge: { ar: 'دولة الكويت | الكويت', en: 'State of Kuwait | Kuwait City' },
    headerTitle: { ar: 'مهرجان عالم الديناصورات الكويت 2026', en: 'Dinosaur World Festival Kuwait 2026' }
  },
  hk: {
    countryBadge: { zh: '香港特別行政區 | 大嶼山', en: 'Hong Kong SAR | Lantau' },
    headerTitle: { zh: '2026 恐龍世界嘉年華 香港站', en: 'Dinosaur World Festival Hong Kong 2026' }
  },
  sg: {
    countryBadge: { en: 'Singapore | Expo' },
    headerTitle: { en: 'Dinosaur World Festival Singapore 2026' }
  },
  my: {
    countryBadge: { en: 'Malaysia | Kuala Lumpur' },
    headerTitle: { en: 'Dinosaur World Festival Malaysia 2026' }
  }
};

export const getTranslations = (geoId, langCode) => {
  const geo = GEOS[geoId] || GEOS.qa;
  const lang = langCode || geo.defaultLang;
  const base = baseTranslations[lang] || (lang === 'ar' ? baseTranslations.ar : (lang === 'zh' ? baseTranslations.zh : baseTranslations.en));

  // Determine localized dates dict
  const dates = {};
  Object.keys(geo.dates).forEach(dateKey => {
    const d = geo.dates[dateKey];
    if (lang === 'ar') {
      dates[dateKey] = { day: d.arDay || d.enDay, dateStr: d.arDate || d.enDate, tag: d.arTag || d.enTag };
    } else if (lang === 'zh') {
      dates[dateKey] = { day: d.zhDay || d.enDay, dateStr: d.zhDate || d.enDate, tag: d.zhTag || d.enTag };
    } else {
      dates[dateKey] = { day: d.enDay, dateStr: d.enDate, tag: d.enTag };
    }
  });

  const overrides = GEO_OVERRIDES[geo.id] || GEO_OVERRIDES.qa;
  const countryBadge = overrides.countryBadge[lang] || overrides.countryBadge.en || overrides.countryBadge.ar || overrides.countryBadge.zh;
  const headerTitle = overrides.headerTitle[lang] || overrides.headerTitle.en || overrides.headerTitle.ar || overrides.headerTitle.zh;
  const venueName = geo.venue[lang] || geo.venue.en || geo.venue.ar || geo.venue.zh;
  const eventDatesText = geo.datesText[lang] || geo.datesText.en || geo.datesText.ar || geo.datesText.zh;
  const currency = geo.currencySymbol[lang] || geo.currencySymbol.en || geo.currencySymbol.ar || geo.currencySymbol.zh || geo.currencyCode;

  // Lang switcher label
  let langToggleLabel = 'ENGLISH';
  if (lang === 'en') {
    if (geo.defaultLang === 'zh') langToggleLabel = '繁體中文';
    else if (geo.defaultLang === 'ar') langToggleLabel = 'العربية';
  }

  // Dynamic validUntil & openPass templates according to each country's actual end date
  const validUntil = geo.validUntilDate?.[lang] || geo.validUntilDate?.en || (lang === 'ar' ? '31 أكتوبر 2026' : (lang === 'zh' ? '2026年11月1日' : '31 October 2026'));

  const openPassValidity = lang === 'ar'
    ? `تذكرة مفتوحة (أي يوم حتى ${validUntil})`
    : (lang === 'zh' ? `全日開放通行證（${validUntil}前有效）` : `Open Pass (Any day until ${validUntil})`);

  const openPassBanner = lang === 'ar'
    ? `تذاكر مفتوحة 100% — صالحة للدخول في أي يوم يناسبك حتى ${validUntil} (09:00 ص – 09:00 م) بدون تعقيد أو تحديد مواعيد مسبقة!`
    : (lang === 'zh' ? `100% 彈性開放通行證 — ${validUntil}前任何營業日隨時直接入場 (09:00 - 21:00)，無需繁瑣預約場次！` : `100% Flexible Open Tickets — Valid for entry any day until ${validUntil} (09:00 AM – 09:00 PM). No date or time reservation needed!`);

  const openPassHours = lang === 'ar'
    ? 'دخول مرن طوال اليوم (09:00 ص – 09:00 م)'
    : (lang === 'zh' ? '全日入場 (09:00 - 21:00)' : 'All-Day Entry (09:00 AM – 09:00 PM)');

  return {
    ...base,
    countryBadge,
    headerTitle,
    venueName,
    eventDatesText,
    validUntil,
    openPassValidity,
    openPassBanner,
    openPassHours,
    currency,
    dates,
    timeSlots: base.timeSlots,
    bannerUrl: geo.banner[lang] || geo.banner.en || geo.banner.ar || geo.banner.zh,
    geoId: geo.id,
    currencyCode: geo.currencyCode,
    phonePrefix: geo.phonePrefix,
    phonePlaceholder: geo.phonePlaceholder,
    seatPrefix: geo.seatPrefix,
    merchantName: geo.merchantName,
    langToggleLabel
  };
};

export const translations = {
  ar: getTranslations('qa', 'ar'),
  en: getTranslations('qa', 'en')
};
